import config from '../../../../config';
import React from 'react';
import {
    CREDITS_ACTION_AVAILABILITY_CONFIRMED,
    CREDITS_ACTION_INITIAL_PURCHASE,
    CREDITS_ACTION_LISTING_PUBLISHED,
    CREDITS_ACTION_NEW_RECOMMENDATION_RECEIVED,
    CREDITS_ACTION_PROFILE_COMPLETE,
    CREDITS_ACTION_PROFILE_VERIFIED,
    CREDITS_ACTION_REFERRAL_INVITER,
    CREDITS_FLIP_AND_WIN_BONUS_CREDITS,
} from '../../../../credits-config';
import {
    AWARD_TYPE_ACCOUNT,
    AWARD_TYPE_RIDER_PROFILE,
    AWARD_TYPE_HORSE_PROFILE,
    AWARD_TYPE_FLIP_WIN,
} from './awardType';
import { checkIfCreditsEventExists } from '../../../../util/credits';
import { GET_RECOMMENDATIONS_FORM } from '../../../EditUserInfoPage/EditUserInfoPage';
const { userTypeHorseowner, userTypeRider } = config;

export default (currentUser, navigate, searchParams) => {
    const { userType } = currentUser?.attributes?.profile?.publicData || {};
    const isLoggedIn = currentUser?.id?.uuid;
    const isRider = userTypeRider === userType;
    const isHorseowner = userTypeHorseowner === userType;
    return [
        {
            id: 'received-invitation',
            credits: '+ 100 Credits',
            heading: 'Einladung erhalten',
            description: 'Registriere dich mit einem Empfehlungslink.',
            actionText: 'Nur mit Link möglich',
            actionAllowed: false,
            show: true,
            type: AWARD_TYPE_ACCOUNT,
        },
        {
            id: 'registration',
            credits: '+ 50 Credits',
            heading: 'Registrierung',
            description: 'Registriere dich ohne Empfehlungslink.',
            actionAllowed: !checkIfCreditsEventExists(currentUser, CREDITS_ACTION_INITIAL_PURCHASE),
            actionHandler: () => navigate('SignupPage'),
            show: true,
            type: AWARD_TYPE_ACCOUNT,
        },
        {
            id: 'invite-friend',
            credits: '+ 50 Credits',
            heading: 'Freund:in einladen',
            description: 'Dein:e Freund:in registriert sich über deinen Empfehlungslink.',
            actionAllowed: !checkIfCreditsEventExists(currentUser, CREDITS_ACTION_REFERRAL_INVITER),
            actionHandler: () => navigate('ReferralPage'),
            show: true,
            type: AWARD_TYPE_ACCOUNT,
        },
        {
            id: 'complete-rider-profile',
            credits: '+ 50 Credits',
            heading: 'Reiter-Profil vervollständigen',
            description: 'Fülle dein Reiter-Profil zu 100% aus.',
            actionAllowed: !checkIfCreditsEventExists(currentUser, CREDITS_ACTION_PROFILE_COMPLETE),
            actionHandler: () => navigate('ProfileSettingsPage', { userType: userTypeRider }),
            show: !isHorseowner,
            type: AWARD_TYPE_RIDER_PROFILE,
        },
        {
            id: 'confirm-availability',
            credits: '+ 20 Credits',
            heading: 'Verfügbarkeit bestätigen',
            description: 'Bestätige die Verfügbarkeit deines Profils.',
            actionAllowed: !checkIfCreditsEventExists(
                currentUser,
                CREDITS_ACTION_AVAILABILITY_CONFIRMED
            ),
            actionHandler: () =>
                navigate(
                    'ProfileSettingsPage',
                    { userType: userTypeRider },
                    { availabilityStatusChange: true }
                ),
            show: !isHorseowner,
            type: AWARD_TYPE_RIDER_PROFILE,
        },
        {
            id: 'verify-account',
            credits: '+ 20 Credits',
            heading: 'Konto verifizieren',
            description: 'Bestätige E-Mail-Adresse und Telefonnummer.',
            actionAllowed: !checkIfCreditsEventExists(currentUser, CREDITS_ACTION_PROFILE_VERIFIED),
            actionHandler: () => navigate('ContactDetailsPage'),
            show: true,
            type: AWARD_TYPE_ACCOUNT,
        },
        {
            id: 'publish-horse',
            credits: '+ 20 Credits',
            heading: 'Pferde-Profil veröffentlichen',
            description: 'Erstelle und veröffentliche dein erstes Pferde-Profil.',
            actionAllowed: !checkIfCreditsEventExists(
                currentUser,
                CREDITS_ACTION_LISTING_PUBLISHED
            ),
            actionHandler: () => navigate('NewListingPage'),
            show: !isRider,
            type: AWARD_TYPE_HORSE_PROFILE,
        },
        {
            id: 'recommendation-for-profile',
            credits: '+ 20 Credits',
            heading: 'Empfehlung für Profil erhalten',
            description: 'Erhalte deine erste Empfehlung für dein Reiter-Profil.',
            actionAllowed: !checkIfCreditsEventExists(
                currentUser,
                CREDITS_ACTION_NEW_RECOMMENDATION_RECEIVED
            ),
            actionHandler: () =>
                navigate('EditUserInfo', {
                    section: GET_RECOMMENDATIONS_FORM,
                    userType: userTypeRider,
                }),
            show: !isHorseowner,
            type: AWARD_TYPE_RIDER_PROFILE,
        },
        {
            id: 'flip-and-win',
            credits: '+ 5 bis 100 Credits',
            heading: (
                <>
                    <span>Gewinnen bei</span>{' '}
                    <span style={{ 'white-space': 'nowrap' }}>Flip & Win</span>
                </>
            ),
            description: 'Decke eine Gewinnkarte beim Kartenspiel Flip & Win auf.',
            actionAllowed: !checkIfCreditsEventExists(
                currentUser,
                CREDITS_FLIP_AND_WIN_BONUS_CREDITS
            ),
            actionHandler: () => navigate('FlipAndWin'),
            show: true,
            type: AWARD_TYPE_FLIP_WIN,
        },
    ];
};
